<template>
    <div :class="'sitebuilder-element-container is-receiver' + hideControl()"
         element="BoxComponent"
         :data-hide-desktop="!this.internal_config.showDesktop"
         :data-hide-mobile="!this.internal_config.showMobile" :id="id"
         :data-tag="dataTag()"
         :style="style()">

        <div v-bind:style="{
       'border-radius': radius,
        backgroundColor: backgroundColor,
        backgroundImage: backgroundImage,
        backgroundSize: backgroundSize,
        backgroundPosition: backgroundPosition,
        backgroundOrigin: backgroundOrigin,
        backgroundRepeat: backgroundRepeat,
        height : height,
        minHeight : minHeight,
        width : width,
        border : border,
        'box-shadow': boxShadow,
       }"
             class="sitebuilder-element-receiver">
            <component v-for="(element,index) in elements" :is="element.name" :config="element.config" :key="index"
                       :id="element.id" :height_start="index" :preview="preview"></component>
        </div>
    </div>
</template>
<script>

	import Model from './Model';

	import ImageComponent from "../Image/Image.vue";
	import TextComponent from "../Text/Text.vue";
	import ButtonComponent from "../Button/Button.vue";
	import MailingBossFormComponent from "../Forms/MailingBossForm/MailingBossForm";
	import SimpleFormComponent from "../Forms/SimpleForm/SimpleForm";

	import YoutubeVideoComponent from "../YoutubeVideo/Youtube";
	import IframeComponent from "../Iframe/Iframe";
	import MenuComponent from "../Menu/Menu";
	import VimeoVideoComponent from "../Vimeo/Vimeo";
	import TimerComponent from "../Timer/Timer";
	import LineVComponent from "../LineV/LineV";
	import LineComponent from "../Line/Line";

	export default {
		name: 'BoxComponent',
		components: {
			LineComponent,
			LineVComponent,
			TimerComponent,
			VimeoVideoComponent,
			MenuComponent,
			IframeComponent,
			YoutubeVideoComponent,
			MailingBossFormComponent,
			Model,
			ImageComponent,
			TextComponent,
			ButtonComponent,
			SimpleFormComponent
		},
		props: ['config', 'childs', 'height_start', 'device', 'id', 'preview'],
		data() {
			return Model.data()
		},
		computed: {
			width() {
				return this.internal_config.width;
			},
			height() {
				return this.internal_config.height;
			},
			minHeight() {
				return this.internal_config.minHeight;
			},
			border() {
				return this.internal_config.border;
			},
			boxShadow() {
				return this.internal_config.boxShadow;
			},
			radius() {
				return this.internal_config.borderRadius;
			},
			backgroundColor() {
				if (/MSIE 10/i.test(navigator.userAgent)) {
					// This is internet explorer 10
					return this.internal_config.backgroundColor.substr(0, 7)
				}

				if (/MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent)) {
					// This is internet explorer 9 or 11
					return this.internal_config.backgroundColor.substr(0, 7)
				}

				if (/Edge\/\d./i.test(navigator.userAgent)) {
					// This is Microsoft Edge
					return this.internal_config.backgroundColor.substr(0, 7)
				}

				return this.internal_config.backgroundColor;
			},
			backgroundImage() {
				if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
					return 'url("' + this.internal_config.backgroundImage + '")';
				}
				return '';
			},
			backgroundPosition() {
				if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
					return this.internal_config.backgroundPosition
				}
				return '';
			},
			backgroundOrigin() {
				if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
					return this.internal_config.backgroundOrigin
				}
				return '';
			},
			backgroundRepeat() {
				if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
					return this.internal_config.backgroundRepeat
				}
				return '';
			},
			backgroundSize() {
				if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
					return this.internal_config.backgroundSize
				}
				return '';
			},
		},
		methods: {

			dataTag(){
				if (this.internal_config.tag) {
					return this.internal_config.tag;
				}
				return '';
			},

			hideControl() {
				var classAdd = '';
				if (!this.internal_config.showMobile) {
					classAdd = classAdd + ' hide-on-mobile'
				}

				if (!this.internal_config.showDesktop) {
					classAdd = classAdd + ' hide-on-desktop'
				}

				return classAdd;
			},

			style() {


				let style = `left:  ${this.internal_config.left};
                     padding-top: ${this.internal_config.paddingTop};
                     padding-left: ${this.internal_config.paddingLeft};
                     z-index: ${this.internal_config.zIndex};
                     padding-right: ${this.internal_config.paddingRight};
                     padding-bottom: ${this.internal_config.paddingBottom};
                     top: ${this.internal_config.top}`;
				return style;
			},
		},
		mounted() {
			let device, childs, id, config;
			({device, childs, id, config} = this.$props);

			if (typeof config.backgroundColor === 'undefined') {
				config.backgroundColor = '#FFFFFF';
			}
			this.internal_config = config;
			this.device = device;

			if (typeof childs === 'undefined') {
				childs = [];
			}
			this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
			if (typeof id !== 'undefined') {
				this.id = id;
			}

			Object.keys(this.props).forEach(prop => {
				if (typeof this.internal_config[prop] === 'undefined') {
					this.internal_config[prop] = this.props[prop];
				}
			});

			this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');

		}
	}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    @media (max-width: 980px) {
        .sitebuilder-element-receiver {
            max-width: 100% !important;
            width: 100% !important;
            height: auto !important;
            min-height: 50px;
        }
    }
</style>
